import React from "react";
import {
  ResponsiveContainer,
  Bar,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";

const AttendanceBarChart = ({ data = [] }) => {
  const defaultData = [
    { name: "Mon", onTime: 0, late: 0 },
    { name: "Tue", onTime: 0, late: 0 },
    { name: "Wed", onTime: 0, late: 0 },
    { name: "Thu", onTime: 0, late: 0 },
    { name: "Fri", onTime: 0, late: 0 },
    { name: "Sat", onTime: 0, late: 0 },
    { name: "Sun", onTime: 0, late: 0 },
  ];

  const datas = data.length > 0 ? data : defaultData;

  return (
    <div>
      <div className="mt-4" style={{ width: "100%", height: 300 }}>
        <ResponsiveContainer>
          <BarChart data={datas}>
            <CartesianGrid
              strokeDasharray="0"
              strokeOpacity={0.3}
              vertical={false}
            />
            <XAxis dataKey="name" strokeOpacity={0} />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="onTime" fill="#3b82f6" radius={4} name="On Time" />
            <Bar dataKey="late" fill="#ef4444" radius={4} name="Late" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AttendanceBarChart;
